var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pricing-root flex flex-col justify-center w-full"},[_c('PricingPlans',{staticClass:"py-16"}),_vm._v(" "),_c('Ribbon',_vm._b({staticClass:"mb-16",attrs:{"variant":"gray"}},'Ribbon',_vm.ribbonData,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }